/* eslint-disable no-undef */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
function RadioButtonSelectedValueSet(name, selectedValue) {
    $(`input[name="${name}"][value="${selectedValue}"]`).prop(
        'checked',
        true,
    );
}

function MarkRequired() {
    $('label span.required').remove();
    $(':input[aria-required="true"]').each((i) => {
        const target = $(':input[aria-required="true"]')[i];
        const label = $(`label[for="${$(target).attr('id')}"]`);
        if (label.length > 0) {
            label.html(`${label.html()} <span class="required" >(Required)</span>`);
        }
    });
}

function BoolVarHasValue(val) {
    return val || val === false;
}

function CleanNavLinks() {
    const curPath = window.location.pathname.split('?')[0].split('/');

    $('a.nav-link, a.sidebar__menu-link').each(function () {
        const $this = $(this);

        if (!$this.attr('href')) {
            return;
        }

        const linkPath = $this.attr('href').split('?')[0].split('/');

        for (let i = 0; i < Math.max(curPath.length, linkPath.length); i++) {
            if (curPath[i] === linkPath[i]) {
                continue;
            }

            if (curPath[i] !== undefined && curPath[i].toLowerCase() === 'index' && linkPath[i] === undefined) {
                continue;
            }

            if (linkPath[i] !== undefined && linkPath[i].toLowerCase() === 'index' && curPath[i] === undefined) {
                continue;
            }

            return;
        }

        $this.addClass('active');
        $this.prop('href', '#');
        $this.attr('aria-current', 'page');
    });
}

// alertTypes are success, danger, warning, info
function ShowAlert(target, alertType, message) {
    target.html('');
    const iconType = alertType === 'danger' ? 'error' : alertType;
    target.append(
        $('<div />', {
            class: `alert alert-dismissible alert-${alertType}`,
            role: 'alert',
            tabindex: 0,
            'aria-live': 'polite',
        })
            .append(
                $('<button />', {
                    type: 'button',
                    class: 'close',
                    'data-dismiss': 'alert',
                    'aria-label': 'Close',
                }).append(
                    $('<span />', {
                        'aria-hidden': 'true',
                        html: '&times;',
                    }),
                ),
            )
            .append(
                $('<div />', {
                    class: 'alert__body',
                })
                    .append(
                        $('<div />', {
                            class: 'alert__icon',
                        }).append(
                            $('<i />', {
                                'aria-hidden': 'true',
                                class: `icon-alert_${iconType}`,
                            }),
                        ),
                    )
                    .append(
                        $('<div />', {
                            class: 'alert__content',
                            'aria-live': 'assertive',
                        }).append($('<p />').append(message)),
                    ),
            ),
    );
}

function showAndFocusAlert(targetSelector, type, message) {
    window.ShowAlert($(`#${targetSelector}`), type, message);
    $(`#${targetSelector} .alert`).focus();
}

function ClearAlert(target) {
    target.html('');
}

function ShowModal(
    title,
    bodyContent,
    dismissBtnDescr,
    confirmBtnDescr,
    confirmCallBack,
) {
    $('.modal-title').html(title);
    $('.modal-body-content').html(bodyContent);
    $('#modal-button-cancel').html(dismissBtnDescr);
    $('#modal-button-confirm').html(confirmBtnDescr);

    $('#modal-button-confirm').click(confirmCallBack);

    $('#confirmModal').modal();
}

function ShowInfoModal(
    title,
    bodyContent,
    dismissBtnDescr,
) {
    $('.modal-title').html(title);
    $('.modal-body-content').html(bodyContent);
    $('#modal-button-close').html(dismissBtnDescr);

    $('#infoModal').modal();
}

function ShowModalById(
    id,
    title,
    bodyContent,
    dismissBtnDescr,
    confirmBtnDescr,
    confirmCallBack,
) {
    $(`#${id} .modal-title`).html(title);
    $(`#${id} .modal-body-content`).html(bodyContent);
    $('#modal-button-cancel').html(dismissBtnDescr);
    $('#modal-button-confirm').html(confirmBtnDescr);

    $('#modal-button-confirm').click(confirmCallBack);

    $('#confirmModal').modal();
}

function hideSpinner(id) {
    $(id).waitMe('hide');
}

function ToggleOverride(overridden) {
    if (overridden) {
        $('[data-overridable="true"]').removeAttr('required');
    } else {
        $('[data-overridable="true"]').attr('required', true);
    }
}

function setFocus(controlId) {
    if (controlId) {
        const element = document.getElementById(controlId);
        if (element) {
            element.focus();
        }
    }

    return false;
}

function ajaxPost(url, data, options) {
    const defaults = {
        success: null,
        error: null,
        always: null,
        invalid: null,
        tokenSelector: 'input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        processData: true,
    };

    const settings = $.extend({}, defaults, options);

    const csrfToken = $(settings.tokenSelector).val();
    const headers = {};

    if (csrfToken) {
        headers.RequestVerificationToken = csrfToken;
    }

    $.ajax({
        url: url,
        type: 'POST',
        contentType: settings.contentType,
        dataType: settings.dataType,
        data: data,
        headers: headers,
        processData: settings.processData,
    })
        .done((response) => {
            if (settings.success) {
                settings.success(response);
            }
        })
        .fail((jqXHR, textStatus, errorThrown) => {
            // By having the "&& settings.invalid" it'll fallback to the error callback if the invalid callback isn't defined
            if (
                (jqXHR.status === 400 || jqXHR.status === 422)
                && settings.invalid
            ) {
                settings.invalid(jqXHR.responseJSON);
            } else if (settings.error) {
                settings.error(jqXHR, textStatus, errorThrown);
            }
        })
        .always(() => {
            if (settings.always) {
                settings.always();
            }
        });
}

function ajaxPostJSON(url, jsonData, options) {
    const data = JSON.stringify(jsonData);
    return ajaxPost(url, data, {
        ...options,
        contentType: 'application/json; charset=utf-8',
    });
}

function ajaxPostFormData(url, formData, options) {
    return ajaxPost(url, formData, {
        ...options,
        contentType: false,
        processData: false,
    });
}

function ajaxPostWithCsrfToken(url, pData, funcSuccess, funcError, funcAlways) {
    const jsData = JSON.stringify(pData);

    $.ajax({
        url: url,
        data: jsData,
        headers: {
            RequestVerificationToken: $(
                'input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]',
            ).val(),
        },
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
    })
        .done(funcSuccess)
        .fail(funcError)
        .always(funcAlways);
}

function ajaxPostwithCSRFToken(url, pData, funcSuccess) {
    const jsData = JSON.stringify(pData);

    $.ajax({
        url: url,
        data: jsData,
        headers: {
            RequestVerificationToken: $(
                'input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]',
            ).val(),
        },
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'POST',
    })
        .done(funcSuccess)
        .fail((_, textStatus) => {
            // eslint-disable-next-line no-alert
            alert(`Request failed: ${textStatus}`);
        });
}

function ajaxPostWithFormData(url, formData, doneFunc) {
    $.ajax({
        url: url,
        data: formData,
        headers: {
            RequestVerificationToken: $(
                'input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]',
            ).val(),
        },
        processData: false,
        contentType: false,
        type: 'POST',
    })
        .done(doneFunc)
        .fail(doneFunc);
}

function ajaxDeleteWithCSRFToken(url, funcSuccess) {
    $.ajax({
        url: url,
        headers: {
            RequestVerificationToken: $(
                'input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]',
            ).val(),
        },
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'DELETE',
    })
        .done(funcSuccess)
        .fail((_, textStatus) => {
            // eslint-disable-next-line no-alert
            alert(`Request failed: ${textStatus}`);
        });
}

function showSpinnerWithLabel(selector, ariaLabel) {
    const effect = 'win8_linear';
    $(selector).waitMe({
        effect: effect,
        text: ariaLabel,
        bg: 'rgba(255,255,255,0.7)',
        color: '#000',
        maxSize: '',
        waitTime: -1,
        source: '',
        textPos: 'vertical',
        fontSize: '',
        onClose: () => {},
    });

    $('.waitMe').attr('aria-live', 'assertive');
}

function showSpinner(selector, isSearch = true) {
    if (isSearch) {
        showSpinnerWithLabel(selector, 'Loading Search Results');
        return;
    }

    showSpinnerWithLabel(selector, 'Loading...');
}

function ajaxGetWithCSRFToken(
    url,
    loadingEl,
    successCallback,
    errorCallback,
    completeCallback,
) {
    showSpinner(loadingEl, false);
    $.ajax({
        url: url,
        headers: {
            RequestVerificationToken: $(
                'input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]',
            ).val(),
        },
        method: 'GET',
        success: successCallback,
        error: errorCallback,
        complete: () => {
            completeCallback();
            hideSpinner(loadingEl);
        },
    });
}

function reloadSidebar() {
    const sidebarEl = '#sidebar-wrapper';
    return ajaxGetWithCSRFToken(
        '/home/GetSidebarPartial',
        sidebarEl,
        (data) => {
            $(sidebarEl).html(data);
        },
        (data) => {
            alert.text(data);
        },
        () => { },
    );
}

function CreateLinks(content) {
    const reg = /\[(.*)\]/g;
    // eslint-disable-next-line prefer-object-spread
    let newContent = Object.assign({}, content);
    let linkContent = reg.exec(newContent);
    while (linkContent !== null) {
        const linkHref = linkContent[1].match(/\((.*)\)/);
        if (linkHref) {
            const linkText = linkContent[1].replace(linkHref[0], '');
            const link = $('<a />', {
                href: linkHref[1],
                html: linkText,
            }).prop('outerHTML');
            newContent = content.replace(linkContent[0], link);
        }
        linkContent = reg.exec(newContent);
    }

    return newContent;
}

function LoadStateDropDownAndSetValue(countryCd, stateCd, target) {
    const postData = { CountryCd: countryCd || 'US' };
    ajaxPostwithCSRFToken('/api/general/StateDropDown', postData, (msg) => {
        if (msg.success) {
            target.children('option:not(:first)').remove();
            $.each(msg.data, (idx, value) => {
                target.append(
                    $('<option />', {
                        value: value.stateAbbr,
                        html: value.stateDescr,
                    }),
                );
            });
            target.val(stateCd);
        }
    });
}

function LoadCountyDropDownAndSetValue(countryCd, stateCd, countyCd, target) {
    const postData = { CountryCd: countryCd || 'US', StateCd: stateCd };
    ajaxPostwithCSRFToken(
        '/api/general/CountyDropDown',
        postData,
        (msg) => {
            if (msg.success) {
                $('#AppCountyFIPS').children('option:not(:first)').remove();
                $.each(msg.data, (_, value) => {
                    $('#AppCountyFIPS').append(
                        $('<option />', {
                            value: value.countyFIPS,
                            html: value.countyDescr,
                        }),
                    );
                });
                target.val(countyCd);
            }
        },
    );
}

function WatchStateChange(stateTarget, countryTarget, countyTarget) {
    if (!countyTarget) return;
    stateTarget.change((e) => {
        const postData = { CountryCd: countryTarget.val(), StateCd: $(e.target).val() };
        ajaxPostwithCSRFToken(
            '/api/general/CountyDropDown',
            postData,
            (msg) => {
                if (msg.success) {
                    countyTarget.children('option:not(:first)').remove();
                    $.each(msg.data, (_, value) => {
                        countyTarget.append(
                            $('<option />', {
                                value: value.countyFIPSCd,
                                html: value.countyDescr,
                            }),
                        );
                    });
                }
            },
        );
    });
}

function WatchCountryChange(countryTarget, stateTarget, countyTarget) {
    if (!countryTarget) return;
    countryTarget.change((e) => {
        const postData = { CountryCd: $(e.target).val() };
        ajaxPostwithCSRFToken(
            '/api/general/StateDropDown',
            postData,
            (msg) => {
                if (msg.success) {
                    if (countyTarget) {
                        countyTarget.children('option:not(:first)').remove(); // Clear County Options until State is Chosen
                    }

                    stateTarget.children('option:not(:first)').remove(); // Clear State Selection
                    $.each(msg.data, (_, value) => {
                        stateTarget.append(
                            $('<option />', {
                                value: value.stateAbbr,
                                html: value.stateDescr,
                            }),
                        );
                    });
                }
            },
        );
    });
}

function ZIPCodeChange(
    zipTarget,
    cityTarget,
    stateTarget,
    countryTarget,
    countyTarget,
) {
    if (zipTarget.val()) {
        const origZip = zipTarget.val().replace(/[\W_]+/g, '');
        zipTarget.data('orig', origZip);
    }
    zipTarget.focusout((e) => {
        const newZIP = $(e.target)
            .val()
            .replace(/[\W_]+/g, '');
        if (newZIP === zipTarget.data('orig')) {
            return;
        }
        const postData = { ZIPCode: newZIP };
        ajaxPostwithCSRFToken('/api/general/ZIPLookup', postData, (msg) => {
            if (msg.success) {
                if (msg.data) {
                    cityTarget.val(msg.data.city);
                    if (countryTarget) {
                        countryTarget.val(msg.data.countryCd);
                    }
                    LoadStateDropDownAndSetValue(
                        msg.data.countryCd,
                        msg.data.stateCd,
                        stateTarget,
                    );
                    if (countyTarget) {
                        LoadCountyDropDownAndSetValue(
                            msg.data.countryCd,
                            msg.data.stateCd,
                            msg.data.countyFIPS,
                            countyTarget,
                        );
                    }
                    zipTarget.data('orig', newZIP);
                }
            }
        });
    });
}

let jsonDates;

function ConfigureDateSelection(targetStartDt, targetEndDt, targetDropDown) {
    const url = '/api/general/DateDropDown';
    ajaxPostwithCSRFToken(url, null, (msg) => {
        jsonDates = msg.data;
        $.each(jsonDates, (_, data) => {
            targetDropDown.append(new Option(data.descr, data.id));
        });
    });

    targetDropDown.change((e) => {
        const selId = $(e.target).val();

        $.each(jsonDates, (_, data) => {
            if (selId === data.id.toString()) {
                const startDt = window.moment(data.startDate);
                const endDt = window.moment(data.endDate);
                if (startDt.isValid()) {
                    targetStartDt.val(startDt.format('YYYY-MM-DD'));
                } else {
                    targetStartDt.val('');
                }
                if (endDt.isValid()) {
                    targetEndDt.val(endDt.format('YYYY-MM-DD'));
                } else {
                    targetEndDt.val('');
                }
            }
        });
    });
}

// TODO: Refactor to addresses
function FullAutoAddressWireUp(
    zipTarget,
    cityTarget,
    stateTarget,
    countryTarget,
    countyTarget,
) {
    ZIPCodeChange(
        zipTarget,
        cityTarget,
        stateTarget,
        countryTarget,
        countyTarget,
    );
    WatchStateChange(stateTarget, countryTarget, countyTarget);
    WatchCountryChange(countryTarget, stateTarget, countyTarget);
}

function DisplayRefDescr() {
    $('[data-refdata-group]').each((i) => {
        const target = $('[data-refdata-group]')[i];
        const group = $(target).data('refdata-group');
        let code = $(target).data('refdata-code');

        if ($(target).data('refdata-source')) {
            code = $(`#${$(target).data('refdata-source')}`).val();
        }

        if (code) {
            if ($(target).is(':input')) {
                $(target).val(window.describeRefData(group, code));
            } else {
                $(target).text(window.describeRefData(group, code));
            }
        }
    });
}

function GetAge(dateOfBirth, ageDate) {
    const dob = window.moment(dateOfBirth, 'MM/DD/YYYY');
    const testDate = ageDate ? window.moment(ageDate, 'MM/DD/YYYY') : window.moment();
    let age = 'Unknown';

    if (ageDate === '') {
        return age;
    }

    if (dob.isValid() && testDate.isValid()) {
        age = testDate.diff(dob, 'years');
    }

    return age;
}

function GetDateDiff(startDt, endDt) {
    let days = 'Unknown';

    if (!startDt) {
        return days;
    }

    if (!endDt) {
        return days;
    }

    const start = window.moment(startDt, 'MM/DD/YYYY');
    const end = window.moment(endDt, 'MM/DD/YYYY');

    if (start.isValid() && end.isValid()) {
        days = start.diff(end, 'days');
    }
    return days;
}

function makeSelect2MultiSelectAccessible(id, labelId, valuesDescriptionId) {
    $(id).closest('.form-group').find('.select2-search__field').attr('aria-labelledby', `${labelId} ${valuesDescriptionId}`);

    const valuesDescriptionLabel = $(`#${valuesDescriptionId}`);

    valuesDescriptionLabel.text('');

    $(`${id} option:selected`).each((e) => {
        const $this = $(`${id} option:selected`)[e];
        if ($this) {
            const selectedValueText = $this.text;

            const valueText = valuesDescriptionLabel.text();
            if (valueText) {
                valuesDescriptionLabel.text(`${valueText}, ${selectedValueText}`);
            } else {
                valuesDescriptionLabel.text(selectedValueText);
            }
        }
    });
}

function replaceClass(element1, element2, className) {
    if (!element2.hasClass(className)) return;
    element1.removeClass();
    element1.addClass(className);
    element2.removeClass(className);
}

function replaceAttribute(element1, element2, attrName, attrVal) {
    element1.attr(attrName, attrVal);
    element2.removeAttr(attrName);
}

function CopytoClipboard(valueToCopy, appendTarget) {
    const $clipdata = $('<input />', {
        value: valueToCopy,
        readonly: true,
        style: {
            position: 'absolute',
            left: '-999999px',
        },
    });
    if (appendTarget) {
        appendTarget.append($clipdata);
    } else {
        $('body').append($clipdata);
    }
    $clipdata.select();
    document.execCommand('copy');
    $clipdata.remove();
}

function LoadAddrDropDown(targetDropDown, targetAddrLine1, targetZip) {
    targetDropDown.children('option:not(:first)').remove();
    $.each(window.jsonEmpAddrBook, (idx, item) => {
        targetDropDown.append(
            $('<option />', {
                text:
                    `${item.eaLocationDescr
                    } (${item.eaCity
                    }, ${item.eaStateCd
                    })`,
                value: idx,
                selected:
                    item.eaZip === targetZip.val().replace(/[\W_]+/g, '')
                    && item.eaAddressLine1 === targetAddrLine1.val(),
            }),
        );
    });
}

// Address Book Functions
function EmpAddrBookActions(
    empId,
    targetDDL,
    targetAddrLine1,
    targetAddrLine2,
    targetCity,
    targetState,
    targetZip,
    targetCountry,
) {
    if (!empId) {
        return;
    }

    const postData = { Id: empId };

    ajaxPostwithCSRFToken(
        '/api/General/EmployerAddressBookList',
        postData,
        (msg) => {
            if (msg.success) {
                window.jsonEmpAddrBook = msg.data;
                LoadAddrDropDown($('#selEmployerAddr'), targetAddrLine1, targetZip);
            }
        },
    );

    targetDDL.change((e) => {
        const idx = $(e.target).val();
        const addrDetail = window.jsonEmpAddrBook[idx];
        targetAddrLine1.val(addrDetail.eaAddressLine1);
        targetAddrLine2.val(addrDetail.eaAddressLine2);
        targetCity.val(addrDetail.eaCity);
        targetState.val(addrDetail.eaStateCd);
        targetZip.val(addrDetail.eaZip);
        targetZip.trigger('unmask');
        targetCountry.val(addrDetail.eaCountryCd);
    });
}

function GetFilenameFromContentDispositionHeader(xhr) {
    let filename = '';
    const disposition = xhr.getResponseHeader('Content-Disposition');
    if (disposition && disposition.indexOf('attachment') !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches !== null && matches[1]) {
            filename = matches[1].replace(/['"]/g, '');
        }
    }
    return filename;
}

function XHRPostWithCSRFToken(postData, url, callback, errorCallback, linkParent) {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(xhr.response);
            a.download = GetFilenameFromContentDispositionHeader(xhr);
            a.style.display = 'none';
            (linkParent ?? document.body).appendChild(a);
            a.click();
            if (callback && typeof callback === 'function') {
                callback();
            }
        } else if (xhr.readyState === 2 && (xhr.status === 400 || xhr.status === 500)) {
            xhr.responseType = 'text';
        } else if (xhr.readyState === 4 && xhr.status === 400) {
            if (errorCallback && typeof errorCallback === 'function') {
                errorCallback(JSON.parse(xhr.responseText));
            }
        } else if (xhr.readyState === 4 && xhr.status === 500) {
            if (errorCallback && typeof errorCallback === 'function') {
                errorCallback('An error occurred while processing your request.');
            }
        }
    };
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader(
        'RequestVerificationToken',
        $('input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]').val(),
    );
    xhr.responseType = 'blob';
    xhr.send(JSON.stringify(postData));
}

function xhrGetWithCsrfToken(url, callback, errorCallback) {
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = () => {
        if (xhr.readyState === 4 && xhr.status === 200) {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(xhr.response);
            a.download = GetFilenameFromContentDispositionHeader(xhr);
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            if (callback && typeof callback === 'function') {
                callback();
            }
        } else if (xhr.readyState === 2 && xhr.status === 400) {
            xhr.responseType = 'text';
        } else if (xhr.readyState === 4 && (xhr.status === 400 || xhr.status === 500)) {
            if (errorCallback && typeof errorCallback === 'function') {
                errorCallback();
            }
        }
    };
    xhr.open('GET', url);
    xhr.setRequestHeader(
        'RequestVerificationToken',
        $('input[name="CSRF-TOKEN-AJLA-WOTC-FORM"]').val(),
    );
    xhr.responseType = 'blob';
    xhr.send();
}

function addValueToElement(identifier, value) {
    if (value) {
        $(identifier).text(value);
    }
}

function throttle(callback, limit, waiting) {
    return (...args) => {
        if (!waiting) {
            callback.apply(window, args);
            // eslint-disable-next-line no-param-reassign
            waiting = true;
            setTimeout(() => {
                // eslint-disable-next-line no-param-reassign
                waiting = false;
            }, limit);
        }
    };
}

function disableLoadingButton(element, buttonTextElement, loadingIndicatorElement) {
    element.disabled = true;
    buttonTextElement.innerText = 'Loading...';
    loadingIndicatorElement.style.display = '';
}

function enableLoadingButton(element, buttonTextElement, loadingIndicatorElement) {
    element.disabled = false;
    buttonTextElement.innerText = element.dataset.origText;
    loadingIndicatorElement.style.display = 'none';
}

function attachLoadingObserver(watchedElementId, loadingClass, loadingCallback, notLoadingCallback) {
    const resultsElement = document.getElementById(watchedElementId);

    if (resultsElement === null) {
        // TODO: log error to Sentry
        // eslint-disable-next-line no-alert
        alert(`Error: could not find element with id ${watchedElementId}`);
        return;
    }

    const observer = new MutationObserver((mutations) => {
        Array.prototype.forEach.call(mutations, (mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (mutation.target.classList.contains(loadingClass)) {
                    loadingCallback();
                } else {
                    // Add a slight delay to avoid a race condition with the throttling.
                    setTimeout(() => {
                        notLoadingCallback();
                    }, 500);
                }
            }
        });
    });

    observer.observe(resultsElement, { attributes: true });
}

Array.prototype.forEach.call(document.getElementsByClassName('loading-spinner'), (element) => {
    const originalText = element.innerText;

    element.dataset.origText = originalText;

    const loadingIndicator = document.createElement('span');
    loadingIndicator.classList.add('loading-indicator', 'spinner-border', 'spinner-border-sm', 'mr-1');
    loadingIndicator.setAttribute('role', 'status');
    loadingIndicator.setAttribute('aria-hidden', 'true');
    loadingIndicator.style.display = 'none';

    const buttonText = document.createElement('span');
    buttonText.innerText = originalText;
    buttonText.classList.add('button-text');

    element.innerText = '';
    element.appendChild(loadingIndicator);
    element.appendChild(buttonText);

    if (element.dataset.loadingClass === 'waitMe_container') {
        const elemIdentifier = element.id ? `ID '${element.id}'` : `class list '${element.classList}'`;
        // eslint-disable-next-line no-console
        console.log(`Consider using 'data-wait-me-container-id' instead of 'results-element-id' and 'data-loading-class' for element with ${elemIdentifier}`);
    }

    if (element.dataset.waitMeContainerId) {
        attachLoadingObserver(
            element.dataset.waitMeContainerId,
            'waitMe_container',
            () => { disableLoadingButton(element, buttonText, loadingIndicator); },
            () => { enableLoadingButton(element, buttonText, loadingIndicator); },
        );
    } else if (element.dataset.resultsElementId !== undefined && element.dataset.loadingClass !== undefined) {
        attachLoadingObserver(
            element.dataset.resultsElementId,
            element.dataset.loadingClass,
            () => { disableLoadingButton(element, buttonText, loadingIndicator); },
            () => { enableLoadingButton(element, buttonText, loadingIndicator); },
        );
    } else {
        // For use with submitted forms or manually re-enabling the button.
        element.addEventListener('click', () => {
            disableLoadingButton(element, buttonText, loadingIndicator);
            element.form?.submit();
        });
    }
});

function initDatePickers(selector) {
    if ($(selector).length) {
        $(selector)
            .datepicker({
                markup: 'bootstrap4',
                dateFormat: 'mm/dd/yy',
                theme: 'bootstrap',
                gainFocusOnConstruction: false,
                outputFormat: 'MM/dd/yyyy',
                inputFormat: [
                    'MM/DD/YYYY',
                    'M/d/y',
                    'M-d-y',
                    'yyyy-MM-dd',
                    'yyyy/MM/dd',
                    'd/M/y',
                    'd-M-y',
                    'd.M.y',
                    'ddMMy',
                    'yyyy.MM.dd',
                    'M/d/yy',
                ],
            })
            .on('blur', (e) => {
                if ($(e.target).val() !== '') {
                    $(e.target).datepicker('setDate', $(e.target).datepicker('getDate'));
                }
            });

        $(selector).attr('placeholder', '');
    }

    $('.datepicker-button').prop('tabindex', '-1');
    $('.datepicker-button').attr('aria-hidden', 'true');
    $('.datepickerDiv .input-group').addClass('d-flex flex-nowrap');
}

const concatenateValidationErrors = (validationErrors) => validationErrors.map((error) => error.errorMessage).join(', ');

function setupInputMasks() {
    $('input[data-inputmask]').inputmask({ removeMaskOnSubmit: true });
}

$(() => {
    setFocus('error-summary');
    setFocus('main-alert');

    setupInputMasks();

    initDatePickers('.datepicker');

    // Mimic browser back function
    $('.go_back').click(() => window.history.back());

    // Fill in sitedata
    $('.SiteData').each((i) => {
        const target = $('.SiteData')[i];
        if ($(target).data('customvalue-replace') === true) {
            $(target).replaceWith(window.jsonRefData.SiteData[$(target).data('customvalue')]);
        } else {
            $(target).html(window.jsonRefData.SiteData[$(target).data('customvalue')]);
        }
    });

    // Cleanup Dates that are null
    $('input[readonly][type="datetime-local"][value=""]').each((i) => {
        const target = $('input[readonly][type="datetime-local"][value=""]')[i];
        $(target).prop('type', 'text').val('Never');
    });

    // To handle Checkboxes since .net adds a 2nd checkbox for postback
    $('[data-ischecked="True"]').each((i) => {
        const target = $('[data-ischecked="True"]')[i];
        $(target).attr('checked', 'checked');
    });

    // Link up checkboxes to toggle data
    $('[data-toggle-child]').each((i) => {
        const targetEl = $('[data-toggle-child]')[i];
        const showOn = $(targetEl).data('toggle-display-on');
        const target = $(targetEl).data('toggle-child');
        $(target).toggle($(targetEl).is(':checked') === showOn);
    });

    CleanNavLinks();

    if ($('[data-overridecontrol]').is(':checked')) {
        ToggleOverride(true);
    }

    MarkRequired();

    DisplayRefDescr();

    const padding = 100;

    // Auto-scroll fix
    $('input, textarea, select, span.select2-selection').focus((e) => {
        const elementBottom = $(e.target).offset().top + $(e.target).height();
        const windowScroll = $(window).scrollTop();
        const windowBottom = windowScroll + $(window).height();

        if (elementBottom + padding > windowBottom) {
            $(window).scrollTop(windowScroll + padding);
        }
    });

    $(document).on('change', 'input[type="file"]', (e) => {
        const filename = e.target.files[0].name;
        $(e.target).parent().find('.custom-file-label').text(filename);
    });

    $('[data-toggle="tooltip"]').tooltip();
    $('input[data-type=\'currency\']').on({
        keyup: (e) => {
            window.formatCurrency($(e.target));
        },
        blur: (e) => {
            window.formatCurrency($(e.target), 'blur');
        },
    });
});

$('[data-overridecontrol="true"]').change((e) => {
    const overridden = $(e.target).is(':checked');
    ToggleOverride(overridden);
    MarkRequired();
});

// checkboxes toggle linked objects
$('[data-toggle-child]').change((e) => {
    const showOn = $(e.target).data('toggle-display-on');
    const target = $(e.target).data('toggle-child');
    $(target).toggle($(e.target).is(':checked') === showOn);
});

$('#confirmModal').on('hide.bs.modal', () => {
    // Remove the callbacks on the confirm button when hidden
    $('#modal-button-confirm').off();
});

let trap = {};
let focusTrapContainer = '';
let triggerElement = {};

$(document).on('show.bs.modal', '.modal', (e) => {
    triggerElement = document.activeElement;
});

$(document).on('shown.bs.modal', '.modal', (e) => {
    focusTrapContainer = $(e.target).attr('id');
    trap = focusTrap.createFocusTrap(`#${focusTrapContainer}`);
    trap.activate();
});

$(document).on('hide.bs.modal', '.modal', (e) => {
    trap.deactivate();
    focusTrapContainer = '';
    trap = {};
});

$(document).on('hidden.bs.modal', '.modal', (e) => {
    if (triggerElement.id) {
        document.getElementById(triggerElement.id).focus();
    }

    triggerElement = {};
});

$(() => {
    $('[data-toggle="popover"]').popover();
});

$(window).click(() => {
    $('[data-toggle="popover"]').popover('hide');
});

function makeSelect2Accessible() {
    $('.select2-search__field').attr('aria-label', 'textbox');
    $('.select2-search__field').attr('type', 'text');
    $('.select2-selection__clear').attr('aria-hidden', 'true');
    $('.select2-selection--single').attr(
        'aria-describedby',
        (e) => $(e.target).closest('.form-group').find('select').attr('aria-describedby'),
    );
}

function getLabelByForAttribute(id) {
    const label = $(`label[for="${id}"]`);
    if (label.length) {
        return label;
    }

    return null;
}

function getLabelByAriaLabelledByAttribute($element) {
    const labelledById = $element.attr('aria-labelledby');
    if (!labelledById) {
        return null;
    }

    const label = $(`#${labelledById}`);
}

function getLabelForElement($element) {
    const id = $element.attr('id');
    if (id) {
        const $label = getLabelByForAttribute(id);
        if ($label) {
            return $label;
        }
    }

    const $label = getLabelByAriaLabelledByAttribute($element);

    if ($label) {
        return $label;
    }

    console.error('No label found for: ', $element);
    return null;
}

function makeSelect2InputAccessible($element) {
    const labelForSelect = getLabelForElement($element);
    let labelId = null;
    let elementId = $element.attr('id');

    if (!elementId) {
        console.warn('No id found for select2 input ', $element);
        elementId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        $element.attr('id', elementId);
    }

    if (labelForSelect.length) {
        labelId = labelForSelect.attr('id');
        if (!labelId) {
            labelId = `${elementId}-label`;
            labelForSelect.attr('id', labelId);
        }
    } else {
        console.error(`No label found for select2 input with id ${id}`);
    }

    const select2Container = $(`#select2-${elementId}-container`);

    select2Container.attr(
        'aria-labelledby',
        labelId,
    );
    select2Container.parent().attr(
        'aria-labelledby',
        labelId,
    );
}

$.fn.selectWooAccessible = function (options) {
    this.selectWoo(options);

    const id = this.attr('id');
    this.on('select2:unselect', (evt) => {
        const select2Element = document.getElementById(id);
        const select2Data = $(select2Element).data('select2');
        const placeholderText = select2Data.selection.placeholder.text;
        $(`#select2-${id}-container`).prop('title', placeholderText);
    });
    makeSelect2InputAccessible(this);

    // TODO: Make this work on the select2 dropdown that we're creating in this function
    // rather than global for better performance.
    makeSelect2Accessible();
};
